import theme from '../../../../../lib/theme';
import { CarouselBlockProps } from './CarouselBlock';

const {
  layouts,
  colors,
  scale,
  media,
  font: { families, heights, spacings, ...font },
} = theme;

export default () => ({
  container: {
    ...layouts.column,
    backgroundColor: '#ffeffa',

    alignItems: 'center',
    padding: `${scale.s} ${scale.xs} ${scale.l}`,
  },

  carouselSlide: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    maxHeight: '100%',
    whiteSpace: 'normal',
  },

  backgroundImageWrap: {
    position: 'absolute',
    height: '100%',
    width: '100%',
    backgroundPosition: '50%',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    zIndex: '-1',
  },

  '.content-image-background-slide > .background-image-wrap': {
    filter: `blur(5px)`,
  },
});
